import * as api from '../api';
import { SNACKBAR_DURATION_MS, getSnackbarColor } from "../utils/snackbar";

// Action Types
export const GET_SUBCONTRACTORS = 'GET_SUBCONTRACTORS';
export const GET_SUBCONTRACTOR = 'GET_SUBCONTRACTOR';
export const CREATE_SUBCONTRACTOR = 'CREATE_SUBCONTRACTOR';
export const UPDATE_SUBCONTRACTOR = 'UPDATE_SUBCONTRACTOR';
export const DELETE_SUBCONTRACTOR = 'DELETE_SUBCONTRACTOR';

// Get all subcontractors
export const getSubcontractors = (searchQuery, page, pageSize) => async (dispatch) => {
  try {
    const { data } = await api.fetchSubcontractors(searchQuery, page, pageSize);
    
    dispatch({ 
      type: GET_SUBCONTRACTORS, 
      payload: data 
    });
    
    return data;
  } catch (error) {
    console.error('Error fetching subcontractors:', error);
    throw error;
  }
};

// Get single subcontractor
export const getSubcontractor = (id) => async (dispatch) => {
  try {
    const { data } = await api.fetchSubcontractor(id);
    
    dispatch({ 
      type: GET_SUBCONTRACTOR, 
      payload: data 
    });
    
    return data;
  } catch (error) {
    console.error('Error fetching subcontractor:', error);
    throw error;
  }
};

// Create subcontractor
export const createSubcontractor = (subcontractorData, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.createSubcontractor(subcontractorData);
    
    dispatch({ 
      type: CREATE_SUBCONTRACTOR, 
      payload: data 
    });
    
    openSnackbar('Subcontractor created successfully', SNACKBAR_DURATION_MS, getSnackbarColor("Subcontractor created successfully"));
    
    return data;
  } catch (error) {
    console.error('Error creating subcontractor:', error);
    openSnackbar('Error creating subcontractor', SNACKBAR_DURATION_MS, getSnackbarColor("Error creating subcontractor"));
    throw error;
  }
};

// Update subcontractor
export const updateSubcontractor = (id, subcontractorData, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.updateSubcontractor(id, subcontractorData);
    
    dispatch({ 
      type: UPDATE_SUBCONTRACTOR, 
      payload: data 
    });
    
    openSnackbar('Subcontractor updated successfully', SNACKBAR_DURATION_MS, getSnackbarColor("Subcontractor updated successfully"));
    
    return data;
  } catch (error) {
    console.error('Error updating subcontractor:', error);
    openSnackbar('Error updating subcontractor', SNACKBAR_DURATION_MS, getSnackbarColor("Error updating subcontractor"));
    throw error;
  }
};

// Delete subcontractor
export const deleteSubcontractor = (id, openSnackbar) => async (dispatch) => {
  try {
    await api.deleteSubcontractor(id);
    
    dispatch({ 
      type: DELETE_SUBCONTRACTOR, 
      payload: id 
    });
    
    openSnackbar('Subcontractor deleted successfully', SNACKBAR_DURATION_MS, getSnackbarColor("Subcontractor deleted successfully"));
  } catch (error) {
    console.error('Error deleting subcontractor:', error);
    openSnackbar('Error deleting subcontractor', SNACKBAR_DURATION_MS, getSnackbarColor("Error deleting subcontractor"));
    throw error;
  }
};

// Record payment
export const recordSubcontractorPayment = (id, paymentData, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.recordSubcontractorPayment(id, paymentData);
    
    dispatch({ 
      type: UPDATE_SUBCONTRACTOR, 
      payload: data 
    });
    
    openSnackbar('Payment recorded successfully', SNACKBAR_DURATION_MS, getSnackbarColor("Payment recorded successfully"));
    
    return data;
  } catch (error) {
    console.error('Error recording payment:', error);
    openSnackbar('Error recording payment', SNACKBAR_DURATION_MS, getSnackbarColor("Error recording payment"));
    throw error;
  }
};

// Record billing
export const recordSubcontractorBilling = (id, billingData, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.recordSubcontractorBilling(id, billingData);
    
    dispatch({ 
      type: UPDATE_SUBCONTRACTOR, 
      payload: data 
    });
    
    openSnackbar('Billing recorded successfully', SNACKBAR_DURATION_MS, getSnackbarColor("Billing recorded successfully"));
    
    return data;
  } catch (error) {
    console.error('Error recording billing:', error);
    openSnackbar('Error recording billing', SNACKBAR_DURATION_MS, getSnackbarColor("Error recording billing"));
    throw error;
  }
};

// Update performance rating
export const updateSubcontractorRating = (id, ratingData, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.updateSubcontractorRating(id, ratingData);
    
    dispatch({ 
      type: UPDATE_SUBCONTRACTOR, 
      payload: data 
    });
    
    openSnackbar('Performance rating updated successfully', SNACKBAR_DURATION_MS, getSnackbarColor("Performance rating updated successfully"));
    
    return data;
  } catch (error) {
    console.error('Error updating performance rating:', error);
    openSnackbar('Error updating performance rating', SNACKBAR_DURATION_MS, getSnackbarColor("Error updating performance rating"));
    throw error;
  }
};

// Complete work
export const completeSubcontractorWork = (id, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.completeSubcontractorWork(id);
    
    dispatch({ 
      type: UPDATE_SUBCONTRACTOR, 
      payload: data 
    });
    
    openSnackbar('Work marked as complete successfully', SNACKBAR_DURATION_MS, getSnackbarColor("Work marked as complete successfully"));
    
    return data;
  } catch (error) {
    console.error('Error completing work:', error);
    openSnackbar('Error completing work', SNACKBAR_DURATION_MS, getSnackbarColor("Error completing work"));
    throw error;
  }
};
